

















import { Component, Vue, Prop } from 'vue-property-decorator';
import { Article } from '@/services/articles';
import { articleService } from '../../services';

@Component
export default class ArticleActions extends Vue {
  @Prop() article!: Article;
  @Prop() canModify!: boolean;
  isLoading: boolean = false;

  async deleteArticle() {
    this.isLoading = true;
    try {
      await articleService.deleteArticle(this.article.slug);
      this.isLoading = false;
      this.$router.push({ name: 'home' });
    } catch (e) {
      alert(e);
    }
  }
}
